import React from 'react';

import MailNotificationCardSectionContainer from './MailNotificationCardSection.container';

const NotificationsCard = ({
  mailForAdmin,
  title,
  mailing,
  defaultConfigFromBrand,
  setAllowToChangedElements,
}) => (
  <MailNotificationCardSectionContainer
    mailForAdmin={mailForAdmin}
    title={title}
    mailing={mailing}
    defaultConfigFromBrand={defaultConfigFromBrand}
    setAllowToChangedElements={setAllowToChangedElements}
  />
);

export default NotificationsCard;
